import system from './api-system-url/system'
import business from './api-system-url/business'
import node from './api-system-url/node'
import setting from './api-system-url/setting'
import company from './api-system-url/company'
import vehicle from './api-system-url/vehicle'
import notification from './api-system-url/notification'
import workflow from './api-system-url/workflow'
import user from './api-system-url/user'
import workspace from './api-system-url/workspace'

export default {
  system,
  business,
  node,
  setting,
  company,
  vehicle,
  notification,
  workflow,
  user,
  workspace
}
